import { processRequest } from '../../../services/Api';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import i18n from 'i18next';
import { achievementsModalActionTypes } from './Constants';
import * as achievementsModalActions from './Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';
import * as notificationActions from '../../notification/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			achievementsModalActionTypes.GET_ACHIEVEMENT_DATA,
			handleGetAchievementRequest,
		),
		yield takeLatest(
			achievementsModalActionTypes.HIGHLIGHT_ACHIEVEMENT,
			handleHighlightAchievementRequest,
		),
	]);
}

export function* handleGetAchievementRequest(action) {
	try {
		const { username, achievementId } = action.payload;
		const { data } = yield call(
			processRequest,
			`public/users/${username}/achievements/${achievementId}`,
		);

		yield put(achievementsModalActions.getAchievementSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(achievementsModalActions.getAchievementError());
	}
}

export function* handleHighlightAchievementRequest(action) {
	try {
		const { achievementId, achievementTitle, callback } = action.payload;
		yield call(processRequest, `users/achievements/${achievementId}`, 'PUT', {
			highlighted: true,
		});

		yield put(
			notificationActions.createNotification(
				i18n.t('modals.achievement_modal.highlight_notification', {
					title: achievementTitle,
				})
			),
		);

		yield put(achievementsModalActions.highlightAchievementSuccess());

		if (callback) callback(achievementId);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(achievementsModalActions.highlightAchievementError());
	}
}
